<template>
  <!--
    Barra de progreso genérica (pista + fill + % centrado).
    Tonos por umbral: <25 low, ≥25 mid, ≥60 high, ≥100 complete.
    Layout/colores en Tailwind 2; SCSS solo sombra inset y text-shadow.
  -->
  <div class="epc-progress relative w-full h-4 bg-gray-200 rounded-full overflow-hidden">
    <div
      class="epc-progress__fill absolute inset-y-0 left-0 rounded-full transition-all duration-300"
      :class="fillClass"
      :style="{ width: percent + '%' }"
    />
    <span
      class="epc-progress__label absolute inset-0 flex items-center justify-center font-semibold leading-none tabular-nums"
      :class="labelClass"
    >
      {{ label }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'EpcProgressBar',

  props: {
    value: { type: [Number, String], default: 0 },
    decimals: { type: Number, default: 2 },
  },

  computed: {
    percent() {
      const n = Number(this.value)
      if (!Number.isFinite(n)) return 0
      if (n < 0) return 0
      if (n > 100) return 100
      return n
    },
    label() {
      return `${this.percent.toFixed(this.decimals)}%`
    },
    fillClass() {
      if (this.percent >= 100) return 'bg-green-600'
      if (this.percent >= 60) return 'bg-blue-600'
      if (this.percent >= 25) return 'bg-blue-500'
      return 'bg-blue-300'
    },
    labelClass() {
      if (this.percent >= 60) return 'text-white epc-progress__label--light'
      return 'text-gray-800'
    },
  },
}
</script>

<style lang="scss" scoped>
/* TW2 no tiene inset box-shadow, text-shadow ni tamaños tipográficos finos. */
.epc-progress {
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.04);
}
.epc-progress__label {
  font-size: 0.65rem;
  letter-spacing: 0.01em;
}
.epc-progress__label--light {
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
}
</style>
